export const NAME_REDUCER = 'coupon';

export const PREFIX_ACTIONS = 'coupon_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
